import React, { useState, useEffect, useCallback } from 'react'
import { useParams } from "react-router-dom";
import { useDispatch } from 'react-redux'
import classnames from 'classnames'
import { toastr } from 'react-redux-toastr'
import GeotabApi from 'mg-api-js';
import { useTranslation } from 'react-i18next';

import ModalDelete from '../modals/ModalDelete'
import CustomButton from '../../CustomButton'
import { getAddinConfig, getConvertedURL } from '../../helpers/helperGeotab'
import { companyHash, companyCheckFakeEmails, insertGeotabCompany, getGeotabCompanyByCompanyId } from '../../../action/GeotabActions'

import '../../dump/menuComponents/menuComponents.sass'

const addinConfig = getAddinConfig()

const GeotabCredentialsContainer = (props) => {
	const params = useParams();
	const dispatch = useDispatch();
	const { t, i18n } = useTranslation('translation', { keyPrefix: 'geotab.geotabCredentialsContainer' });
	const [company, setCompany] = useState('')
	const [systemSettings, setSystemSettings] = useState('')
	const [data, setData] = useState({
		email: '',
		password: '',
		database: ''
	})
	const [errMessage, setErrMessage] = useState({
		email: '', // romabogdan@gmail.com
		password: '', // roman2012
		database: '',
	})
	const [modal, setModal] = useState({
		show: false,
		title: '',
		content: '',
		error: false,
	})
	const [toggle_password, setToggle_password] = useState(true);
	const [geotabCompany, setGeotabCompany] = useState(null);
	const [showConfirmUpdate, setShowConfirmUpdate] = useState(false);

	const toggleLoader = useCallback((show) => {
		dispatch({ type: 'TOGGLE_LOADER', payload: show });
	}, [dispatch]);

	useEffect(() => {
		toggleLoader(true);

		const hash = params.companyHash;
		companyHash(hash)
			.then(res => {
				toggleLoader(false);
				setCompany(res.data.response);
			})
			.catch((error) => {
				toggleLoader(false)
				console.log('!gcompanyHash error: ', error)

				let errDescription = i18n.t('errorMessage.errDescription');
				if (error.response.data.response.error) {
					errDescription = error.response.data.response.error
				}
				toastr.error(errDescription)
			});
	}, []);

	const togglePassword = () => {
		setToggle_password(!toggle_password);
	}

	const fillForm = (e) => {
		setData({ ...data, [e.target.name]: e.target.value })
	}

	const getGeotabProvider = (e, t, y) => {
		const { provider } = params;
		switch (provider) {
			case '1':
				return 'my.geotab.com'
				break
			case '2':
				return 'mysyncupfleet.com'
				break
			case '3':
				return 'mypreview.geotab.com'
				break
			case '4':
				return 'gov.geotab.com'
				break
			default:
				return 'undefined'
				break
		}
	}

	const checkForm = (data) => {
		let error = false;
		const updatedErrMessage = { ...errMessage };

		for (let i in data) {
			if (data[i] == '') {
				error = true;
				updatedErrMessage[i] = t('errEnterYour') + i + '!';
			}
			else if (updatedErrMessage[i]) {
				updatedErrMessage[i] = null;
			}
		}

		setErrMessage(updatedErrMessage);
		return error;
	}

	const updateGeotabPairing = () => {
		let dataUpdate = data;
		toggleLoader(true);

		const provider = getGeotabProvider();

		const authentication = {
			credentials: {
				database: dataUpdate.database,
				userName: dataUpdate.email,
				password: dataUpdate.password
			},
			path: provider
		}

		const api = new GeotabApi(authentication);
		api.authenticate(
			(res) => {
				if (res.path && res.credentials && res.credentials.database) {
					const newData = data;
					newData.path = (res.path === 'ThisServer') ? provider : res.path
					newData.database = res.credentials.database
					newData.sessionId = res.credentials.sessionId
					newData.company_id = company.id

					api.multiCall([
						['Get', {
							typeName: 'SystemSettings',
						}],
						['Get', {
							typeName: 'AddIn',
						}],
						['GetNotificationWebRequestTemplates', {
							credentials: {
								database: newData.database,
								userName: newData.email,
								sessionId: newData.sessionId
							}
						}],
					],
						(res) => {
							//* Checks existing of the fake emails: geotab_<partner>_<companyname>_fleet and geotab_<partner>_<companyname>_user
							const hash = params.companyHash;
							companyCheckFakeEmails(hash)
								.then((resFakeEmails, errFakeEmails) => {
									console.log('!companyCheckFakeEmails resFakeEmails, errFakeEmails: ', resFakeEmails, errFakeEmails);
								})
								.catch((errorFakeEmails) => {
									console.log('!companyCheckFakeEmails errorFakeEmails: ', errorFakeEmails);
									let errDescription = i18n.t('errorMessage.errDescription');
									if (errorFakeEmails.response.data.response.error) {
										errDescription = errorFakeEmails.response.data.response.error
									}
									toastr.error(errDescription)
								});

							const systemSettings = res[0][0]
							const addinsList = res[1]
							const notificationWebRequests = res[2]
							let notif_snapshot_exist_id = false;
							let notif_video_exist_id = false;
							let notif_snapshot_and_video_exist_id = false;
							let systemAddinExist = false;
							const multicalls = [];

							newData.fleet_token = systemSettings.companyGuid;

							addinsList.forEach((addin, i) => {
								if (addin?.configuration?.name === 'Dual-Vision Video Camera' && systemAddinExist === false) {
									systemAddinExist = i
								}
							})

							notificationWebRequests.map((notification, i) => {
								if (notification.name == 'Auto-upload snapshot to RoscoLive' && !notif_snapshot_exist_id) {
									notif_snapshot_exist_id = notification.id;
								}
								else if (notification.name == 'Auto-upload video to RoscoLive' && !notif_video_exist_id) {
									notif_video_exist_id = notification.id;
								}
								else if (notification.name == 'Auto-upload snapshot and video clip to RoscoLive' && !notif_snapshot_and_video_exist_id) {
									notif_snapshot_and_video_exist_id = notification.id;
								}
							})

							multicalls.push(
								[systemAddinExist === false ? 'Add' : 'Set', {
									typeName: 'AddIn',
									entity: { configuration: addinConfig },
								}],
							)

							if (notif_snapshot_and_video_exist_id) {
								multicalls.push(
									['Set', {
										typeName: 'NotificationBinaryFile',
										entity: {
											id: notif_snapshot_and_video_exist_id,
											url: getConvertedURL('https://geotab.roscolive.com/api/v1.0/geotab/custom_event/all'),
											name: 'Auto-upload snapshot and video clip to RoscoLive',
											requestType: 'Post',
											postBody: 'hash=3eebc8724325&database={database}&date={date}&time={time}&deviceid={deviceId}&device={device}&serial={serialNumber}&vin={vin}&rule={rule}&diagnostic={diagnostic}&driver={driverName}&driverfn={driverFirstName}&driverln={driverLastName}',
											type: 'WebRequestTemplate',
										},
										credentials: {
											database: newData.database,
											userName: newData.email,
											sessionId: newData.sessionId
										}
									}]
								)
							} else {
								multicalls.push(
									['Add', {
										typeName: 'NotificationBinaryFile',
										entity: {
											url: getConvertedURL('https://geotab.roscolive.com/api/v1.0/geotab/custom_event/all'),
											name: 'Auto-upload snapshot and video clip to RoscoLive',
											requestType: 'Post',
											postBody: 'hash=3eebc8724325&database={database}&date={date}&time={time}&deviceid={deviceId}&device={device}&serial={serialNumber}&vin={vin}&rule={rule}&diagnostic={diagnostic}&driver={driverName}&driverfn={driverFirstName}&driverln={driverLastName}',
											type: 'WebRequestTemplate',
										},
										credentials: {
											database: newData.database,
											userName: newData.email,
											sessionId: newData.sessionId
										}
									}]
								)
							}

							if (notif_snapshot_exist_id) {
								multicalls.push(
									['Set', {
										typeName: 'NotificationBinaryFile',
										entity: {
											id: notif_snapshot_exist_id,
											url: getConvertedURL('https://geotab.roscolive.com/api/v1.0/geotab/custom_event/snapshots'),
											name: 'Auto-upload snapshot to RoscoLive',
											requestType: 'Post',
											postBody: 'hash=3eebc8724325&database={database}&date={date}&time={time}&deviceid={deviceId}&device={device}&serial={serialNumber}&vin={vin}&rule={rule}&diagnostic={diagnostic}&driver={driverName}&driverfn={driverFirstName}&driverln={driverLastName}',
											type: 'WebRequestTemplate',
										},
										credentials: {
											database: newData.database,
											userName: newData.email,
											sessionId: newData.sessionId
										}
									}]
								)
							} else {
								multicalls.push(
									['Add', {
										typeName: 'NotificationBinaryFile',
										entity: {
											url: getConvertedURL('https://geotab.roscolive.com/api/v1.0/geotab/custom_event/snapshots'),
											name: 'Auto-upload snapshot to RoscoLive',
											requestType: 'Post',
											postBody: 'hash=3eebc8724325&database={database}&date={date}&time={time}&deviceid={deviceId}&device={device}&serial={serialNumber}&vin={vin}&rule={rule}&diagnostic={diagnostic}&driver={driverName}&driverfn={driverFirstName}&driverln={driverLastName}',
											type: 'WebRequestTemplate',
										},
										credentials: {
											database: newData.database,
											userName: newData.email,
											sessionId: newData.sessionId
										}
									}]
								)
							}

							if (notif_video_exist_id) {
								multicalls.push(
									['Set', {
										typeName: 'NotificationBinaryFile',
										entity: {
											id: notif_video_exist_id,
											url: getConvertedURL('https://geotab.roscolive.com/api/v1.0/geotab/custom_event/videos'),
											name: 'Auto-upload video to RoscoLive',
											requestType: 'Post',
											postBody: 'hash=3eebc8724325&database={database}&date={date}&time={time}&deviceid={deviceId}&device={device}&serial={serialNumber}&vin={vin}&rule={rule}&diagnostic={diagnostic}&driver={driverName}&driverfn={driverFirstName}&driverln={driverLastName}',
											type: 'WebRequestTemplate',
										},
										credentials: {
											database: newData.database,
											userName: newData.email,
											sessionId: newData.sessionId
										}
									}]
								)
							} else {
								multicalls.push(
									['Add', {
										typeName: 'NotificationBinaryFile',
										entity: {
											url: getConvertedURL('https://geotab.roscolive.com/api/v1.0/geotab/custom_event/videos'),
											name: 'Auto-upload video to RoscoLive',
											requestType: 'Post',
											postBody: 'hash=3eebc8724325&database={database}&date={date}&time={time}&deviceid={deviceId}&device={device}&serial={serialNumber}&vin={vin}&rule={rule}&diagnostic={diagnostic}&driver={driverName}&driverfn={driverFirstName}&driverln={driverLastName}',
											type: 'WebRequestTemplate',
										},
										credentials: {
											database: newData.database,
											userName: newData.email,
											sessionId: newData.sessionId
										}
									}]
								)
							}

							insertGeotabCompany(newData)
								.then((res, err) => {
									console.log('!insertGeotabCompany res', res, err);

									api.multiCall(
										multicalls,
										(res, err) => {
											console.log('!SET SystemSettings res', res, err);
											toggleLoader(false);

											if (err) {
												console.log('!SET SystemSettings error', err);

												let errDescription = i18n.t('errorMessage.errDescription');
												if (err.response.data.response.error) {
													errDescription = err.response.data.response.error
												}
												toastr.error(errDescription)

												return;
											}

											toastr.success("Success", t('toastrCredentialsWereSaved'));
										},
										(a, p) => {
											toggleLoader(false);
											console.log('!SET SystemSettings1 a p: ', a, p);
											toastr.error(i18n.t('errorMessage.errDescription'));
										}
									);
								})
								.catch((error) => {
									console.log('!insertGeotabCompany error: ');
									toggleLoader(false);

									let errDescription = i18n.t('errorMessage.errDescription')
									if (error.response.data.response.error) {
										errDescription = error.response.data.response.error
									}
									toastr.error(errDescription)
								});
						},
						(err) => {
							toggleLoader(false);
							console.log('!GET SystemSettings error: ', err);

							let errDescription = i18n.t('errorMessage.errDescription')
							if (err.response.data.response.error) {
								errDescription = err.response.data.response.error
							}
							toastr.error(errDescription)
						});
				}
				else {
					toggleLoader(false);
					toastr.error(i18n.t('errorMessage.errDescription'));
				}
			},
			(error) => {
				toggleLoader(false);
				console.log('!Geotab Authenticate error: ', error)

				if (error.message) {
					toastr.error(error.message)
				}
				else {
					// toastr.error(i18n.t('errorMessage.errDescription'))
					toastr.error(error)
				}
			}
		)
	}

	const sendForm = async (e) => {
		e.preventDefault();

		const error = checkForm(data)
		if (!error) {
			let resPairingExists
			try {
				resPairingExists = await getGeotabCompanyByCompanyId({ company_id: company.id })
			}
			catch (errRequest) {
				console.log('!Error getGeotabCompanyByCompanyId: ', errRequest);
			}

			const geotabCompany = resPairingExists && !_.isEmpty(resPairingExists.data.response) && resPairingExists.data.response

			if (resPairingExists && geotabCompany && (geotabCompany.database.toLowerCase() !== data.database.toLowerCase() || geotabCompany.email.toLowerCase() !== data.email.toLowerCase())) {
				setGeotabCompany(geotabCompany)
				setShowConfirmUpdate(true)
			}
			else {
				updateGeotabPairing()
			}
		}
	}

	const { email, password, database } = errMessage;

	return (
		<div className="panel-body">
			<h3 className='login-header'>{t('headerGeotabCredentials')}</h3>
			<div className="form-wrapper">

				<form onSubmit={sendForm}>
					<div className={classnames('form-group', { 'has-error': database })} style={{ paddingTop: '10px' }}>
						<label className={`login-label ${(data.database.length) ? 'active' : ''}`}>{t('labelDatabase')}</label>
						<input
							type="text"
							id="myDatabase"
							name="database"
							className="vehicle-search"
							autoComplete="new-password"
							placeholder={t('placeholderDatabase')}
							value={data.database}
							onChange={fillForm}
						/>
						{database && <span className="help-block">{database}</span>}
					</div>
					<div className={classnames('form-group', { 'has-error': email })}>
						<label className={`login-label ${(data.email.length) ? 'active' : ''}`}>{t('labelE-mail')}</label>
						<input
							type="text"
							id="myGemail"
							name="email"
							className="vehicle-search"
							autoComplete="new-password"
							placeholder={t('placeholderE-Mail')}
							value={data.email}
							onChange={fillForm}
						/>
						{email && <span className="help-block">{email}</span>}
					</div>
					<div className={classnames('login-form form-group has-feedback', { 'has-error': password })}>
						<label className={`login-label ${(data.password.length) ? 'active' : ''}`}>{t('labelPassword')}</label>
						<input
							type={toggle_password ? 'password' : 'text'}
							id="myPassword"
							name="password"
							className="vehicle-search"
							data-toggle="password"
							autoComplete="new-password"
							placeholder={t('placeholderPassword')}
							value={data.password}
							onChange={fillForm}
						/>
						<span className="fa fa-eye form-control-feedback" onClick={togglePassword}></span>
						{password && <span className="help-block">{password}</span>}
					</div>
					<div className="change-password-submit form-group submit-btn">
						<CustomButton type="submit" variant='primary' size='lg'>
							{t('btnSave')}
						</CustomButton>
					</div>
				</form>

			</div>

			{showConfirmUpdate && (
				<ModalDelete
					title={t('titleModalDelete')}
					content={t('contentModalDelete', { company_name: `"${company.company_name}"`, database: `"${geotabCompany.database}"`, email: `"${geotabCompany.email}"` })}
					deleteBtnName={t('deleteBtnName')}
					styleView="primary"
					showClose
					closeModal={() => setShowConfirmUpdate(false)}
					deleteModal={() => {
						setShowConfirmUpdate(false);
						updateGeotabPairing();
					}}
				/>
			)}
		</div>
	)
}

export default GeotabCredentialsContainer;
